module.exports = __webpack_public_path__ + "img/what-is-openapihub-thumbnail.f19d32dd.jpg";